import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from '../../components/account/forgot-password.component';
import { LoginComponent } from '../../components/account/login.component';
import { ResetPasswordComponent } from '../../components/account/reset-password.component';
import { NewUserRequestComponent } from '../../components/user-request/new-user-request.component';
import { UserRequestCreatePasswordComponent } from '../../components/user-request/user-request-create-password.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Log In' },
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: { title: 'Reset Password' },
  },
  {
    // Invited users follow this link from their invite email to set a password for the first time.
    path: 'setpassword',
    component: ResetPasswordComponent,
    data: { title: 'Set Password', isNewAccount: true },
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
    data: { title: 'Forgot Password' },
  },
  {
    path: 'supplier/individual',
    component: NewUserRequestComponent,
    data: { title: 'Supplier Individual', organisationSubType: 1 },
  },
  {
    path: 'supplier/generic',
    component: NewUserRequestComponent,
    data: { title: 'Supplier Generic', organisationSubType: 2 },
  },
  {
    path: 'supplier/bespoke',
    component: NewUserRequestComponent,
    data: { title: 'Supplier Bespoke', organisationSubType: 3 },
  },
  {
    path: 'customer/individual',
    component: NewUserRequestComponent,
    data: { title: 'Customer Individual', organisationSubType: 4 },
  },
  {
    path: 'customer/generic',
    component: NewUserRequestComponent,
    data: { title: 'Customer Generic', organisationSubType: 5 },
  },
  {
    path: 'customer/bespoke',
    component: NewUserRequestComponent,
    data: { title: 'Customer Bespoke', organisationSubType: 6 },
  },
  {
    path: 'userrequest/:requestId/:ticket',
    component: UserRequestCreatePasswordComponent,
    data: { title: 'User Registration and Organisation Creation' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
